// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"LD-z","expressButtonContainerWithPayPal":"MD-z","expressButton":"ND-z","or":"OD-z"};